/**
 * Putt Broadie Drill 15FT Reducers
 */
import {
    PUTTBDFIFTEENPOINTS_ACTION,
    ALL_PUTTBDFIFTEENPOINTS,
    ADD_PUTTBDFIFTEENPOINTS,
    ALL_PUTTBDFIFTEENPUTTS,
    ADD_PUTTBDFIFTEENPUTTS,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    puttbdfifteenpointlist:[],
    puttbdfifteenputtlist:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case PUTTBDFIFTEENPOINTS_ACTION:
            return { ...state, loading: true };       

        case ALL_PUTTBDFIFTEENPOINTS:
            return { ...state, loading: false, puttbdfifteenpointlist: action.payload };     
            
        case ADD_PUTTBDFIFTEENPOINTS:
            return { ...state, loading: false }; 
            
        case ALL_PUTTBDFIFTEENPUTTS:
            return { ...state, loading: false, puttbdfifteenputtlist: action.payload };     
            
        case ADD_PUTTBDFIFTEENPUTTS:
            return { ...state, loading: false }; 

        default: return { ...state };

     }
 }